import Counter from "./Counter";

function StatsSection() {
  return (
    <section className="stats-section">
      <div className="container">

        <div className="stat-box">
          <Counter target={50} suffix="+" />
          <p>Data Categories</p>
        </div>

        <div className="stat-box">
          <Counter target={99.6} suffix="%" />
          <p>Verified Accuracy</p>
        </div>

        <div className="stat-box">
          <Counter target={10} suffix="M+" />
          <p>Business Records</p>
        </div>

        <div className="stat-box">
          <h2>Pan India</h2>
          <p>Data Coverage</p>
        </div>

      </div>
    </section>
  );
}

export default StatsSection;